/// <amd-module name="SuiteCommerce.ShippingBar.Main.Configuration"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.ShippingBar.Main.Configuration", ["require", "exports", "SuiteCommerce.ShippingBar.Common.Configuration"], function (require, exports, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var MainConfiguration = /** @class */ (function (_super) {
        __extends(MainConfiguration, _super);
        function MainConfiguration() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        MainConfiguration.barUrlLink = function () {
            return this.get('shippingbar.barUrlLink');
        };
        MainConfiguration.barUrlLinkAlt1 = function () {
            return this.get('shippingbar.barUrlLinkAlt1');
        };
        MainConfiguration.barUrlLinkAlt2 = function () {
            return this.get('shippingbar.barUrlLinkAlt2');
        };
        MainConfiguration.showHeaderBar = function () {
            return this.get('shippingbar.showHeaderBar');
        };
        MainConfiguration.shippingBarHeaderPosition = function () {
            return this.get('shippingbar.shippingBarHeaderPosition');
        };
        MainConfiguration.headerInitialMessage = function () {
            return this.get('shippingbar.headerInitialMessage');
        };
        MainConfiguration.headerMessageAlt1 = function () {
            return this.get('shippingbar.headerMessageAlt1');
        };
        MainConfiguration.headerMessageAlt2 = function () {
            return this.get('shippingbar.headerMessageAlt2');
        };
        MainConfiguration.headerProgressMessage = function () {
            return this.get('shippingbar.headerProgressMessage');
        };
        MainConfiguration.headerCongratsMessage = function () {
            return this.get('shippingbar.headerCongratsMessage');
        };
        MainConfiguration.pdpProgressMessage = function () {
            return this.get('shippingbar.pdpProgressMessage');
        };
        MainConfiguration.itemQualifyMessage = function () {
            return this.get('shippingbar.itemQualifyMessage');
        };
        MainConfiguration.cartInitialMessage = function () {
            return this.get('shippingbar.cartInitialMessage');
        };
        MainConfiguration.cartProgressMessage = function () {
            return this.get('shippingbar.cartProgressMessage');
        };
        MainConfiguration.cartCongratsMessage = function () {
            return this.get('shippingbar.cartCongratsMessage');
        };
        return MainConfiguration;
    }(Configuration_1.Configuration));
    exports.MainConfiguration = MainConfiguration;
});
